import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material/styles'
import { format } from 'date-fns'
import { ReactNode } from 'react'

type KudosTvCardProps = {
  postContent: ReactNode
  primaryColor: string
  icon: ReactNode
  postedDate?: string | null
}

const cardStyle: SxProps = {
  borderRadius: 4,
  p: 4,
  height: '78vh',
}

const KudosTvCard: React.FC<KudosTvCardProps> = ({
  primaryColor,
  postContent,
  icon,
  postedDate,
}) => {
  return (
    <Card sx={{ ...cardStyle, borderLeft: `12px solid ${primaryColor}` }}>
      <Stack height="inherit" direction="column" justifyContent="space-between">
        <Box maxHeight="90%" height="inherit">
          {postContent}
        </Box>

        <Stack direction="row" justifyContent="flex-end" alignItems="center" useFlexGap gap={1}>
          {postedDate && (
            <Typography variant="caption" fontSize="1.25rem">
              {format(postedDate, 'MMMM dd, yyyy')}
            </Typography>
          )}
          <Box sx={{ '& svg': { color: primaryColor, height: 48, width: 48 } }}>{icon}</Box>
        </Stack>
      </Stack>
    </Card>
  )
}

export default KudosTvCard
